import { MEMBERSHIPS_LIMIT } from '../constants/memberships';
export const isInviteDisabled = (invitedMembersNumber) => invitedMembersNumber >= MEMBERSHIPS_LIMIT;
